import React from 'react'
import { useGetTourPackages } from '../hooks/useGetTourPackages';
import '../scss/tour-packages.scss';
import { Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { toCurrencyFormat } from '../utils/utils';
import { toDocumentFormat } from '../utils/dateHelper';
import moment from 'moment';

export const TourPackages = () => {
    const { data, isLoading, error } = useGetTourPackages();

    if (isLoading) {
        return <div>Loading...</div>
    }

    if (error) {
        return <div>Error: {error.message}</div>
    }

    return (
        <div>
            <h1>Туры Умра и Хаджа</h1>
            {data.map((tour) => (
                <div key={tour.id} className='tour-package'>
                    <div className='tour-package-image'>
                        <img src={tour.photo} alt={tour.name} />
                    </div>
                    <div className='tour-package-content'>
                        <Link to={`/tourpackages/${tour.id}`}>
                            <h2>{tour.name}</h2>
                        </Link>
                        <p>{tour.description}</p>
                        <div className='gap-2 mb-4'>
                            <div className='mb-2'>
                                <strong className=''>Дата поездки:</strong>
                            </div>
                            <div>
                                <span>{toDocumentFormat(tour.startDate)} - {toDocumentFormat(tour.endDate)} </span>
                                <span>
                                    ({moment(tour.endDate).diff(moment(tour.startDate), 'days')} <span className=''>ночей</span>)
                                </span>
                            </div>
                        </div>
                        <div className='tour-package-price'>
                            <div className='mb-2'>
                                <strong>Стоимость:</strong>
                            </div>
                            <span>{toCurrencyFormat(tour.price, 'USD')} </span>
                            <span>({toCurrencyFormat(tour.totalPriceInKZT, 'KZT')})</span>
                        </div>
                        <div className='tour-package-button mt-4 ml-auto'>
                            <Link to={`/tourpackages/${tour.id}`}>
                                <Button variant='contained' color='primary'>Подробнее</Button>
                            </Link>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    )
}
